import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NotesRoutingModule } from './notes-routing.module';
import { NotesmenuComponent } from './notesmenu/notesmenu.component';
import { GeneralinformationComponent } from './generalinformation/generalinformation.component';
import { StatementcomplianceComponent } from './statementcompliance/statementcompliance.component';
import { AccountingpoliciesComponent } from './accountingpolicies/accountingpolicies.component';
import { DirectorremunerationComponent } from './directorremuneration/directorremuneration.component';
import { EmployeesComponent } from './employees/employees.component';
import { TaxationComponent } from './taxation/taxation.component';
import { DividendsComponent } from './dividends/dividends.component';
import { InventoriesComponent } from './inventories/inventories.component';
import { IntangibleComponent } from './intangible/intangible.component';
import { LandandbuildingsComponent } from './landandbuildings/landandbuildings.component';
import { PlantmachineryComponent } from './plantmachinery/plantmachinery.component';
import { FurnitureandfittingsComponent } from './furnitureandfittings/furnitureandfittings.component';
import { OfficeequipmentComponent } from './officeequipment/officeequipment.component';
import { MotorvehiclesComponent } from './motorvehicles/motorvehicles.component';
import { FinancialassetsComponent } from './financialassets/financialassets.component';
import { DebtorsComponent } from './debtors/debtors.component';
import { CreditorsComponent } from './creditors/creditors.component';
import { BorrowingsComponent } from './borrowings/borrowings.component';
import { OperatingLeaseCommitmentsComponent } from './operating-lease-commitments/operating-lease-commitments.component';
import { ProvisionsForLiabilitiesComponent } from './provisions-for-liabilities/provisions-for-liabilities.component';
import { ShareCapitalComponent } from './share-capital/share-capital.component';
import { ReservesRetainedProfitComponent } from './reserves-retained-profit/reserves-retained-profit.component';
import { RevaluationReserveComponent } from './revaluation-reserve/revaluation-reserve.component';
import { RelatedPartyTransactionsComponent } from './related-party-transactions/related-party-transactions.component';
import { TransactionsWithDirectorsComponent } from './transactions-with-directors/transactions-with-directors.component';
import { CapitalCommitmentsComponent } from './capital-commitments/capital-commitments.component';
import { ContingentLiabilitiesComponent } from './contingent-liabilities/contingent-liabilities.component';
import { PostBalanceSheetEventsComponent } from './post-balance-sheet-events/post-balance-sheet-events.component';
import { DirectorsBenefitsComponent } from './directors-benefits/directors-benefits.component';
import { TurnoverComponent } from './turnover/turnover.component';
import { OperatingProfitComponent } from './operating-profit/operating-profit.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../../../shared/shared.module';
import { TradecreditorsSoletraderComponent } from './tradecreditors-soletrader/tradecreditors-soletrader.component';
import { LoansandoverdrawnbankSoletraderComponent } from './loansandoverdrawnbank-soletrader/loansandoverdrawnbank-soletrader.component';
import { AccountingbasisSoletraderComponent } from './accountingbasis-soletrader/accountingbasis-soletrader.component';
import { OtherliabilitiesandaccrualsSoletraderComponent } from './otherliabilitiesandaccruals-soletrader/otherliabilitiesandaccruals-soletrader.component';
import { InvestmentsHeldPartnershipComponent } from './investments-held-partnership/investments-held-partnership.component';
import { LoansandotherdebsComponent } from './loansandotherdebs/loansandotherdebs.component';
import { CreditorsmorethanyearComponent } from './creditorsmorethanyear/creditorsmorethanyear.component';
import { ComputerequipmentComponent } from './computerequipment/computerequipment.component';


@NgModule({
  declarations: [
    NotesmenuComponent,
    GeneralinformationComponent,
    StatementcomplianceComponent,
    AccountingpoliciesComponent,
    DirectorremunerationComponent,
    EmployeesComponent,
    TaxationComponent,
    DividendsComponent,
    InventoriesComponent,
    IntangibleComponent,
    LandandbuildingsComponent,
    PlantmachineryComponent,
    FurnitureandfittingsComponent,
    OfficeequipmentComponent,
    MotorvehiclesComponent,
    FinancialassetsComponent,
    DebtorsComponent,
    CreditorsComponent, BorrowingsComponent, OperatingLeaseCommitmentsComponent,
    ProvisionsForLiabilitiesComponent,
    ShareCapitalComponent,
    ReservesRetainedProfitComponent,
    RevaluationReserveComponent,
    RelatedPartyTransactionsComponent,
    TransactionsWithDirectorsComponent,
    CapitalCommitmentsComponent,
    ContingentLiabilitiesComponent,
    PostBalanceSheetEventsComponent,
    DirectorsBenefitsComponent,
    TurnoverComponent,
    OperatingProfitComponent,
    TradecreditorsSoletraderComponent,
    LoansandoverdrawnbankSoletraderComponent,
    AccountingbasisSoletraderComponent,
    OtherliabilitiesandaccrualsSoletraderComponent,
    InvestmentsHeldPartnershipComponent,
    LoansandotherdebsComponent,
    CreditorsmorethanyearComponent,
    ComputerequipmentComponent,
    

  ],
  imports: [
    CommonModule,
    NotesRoutingModule, RouterModule, FormsModule, ReactiveFormsModule, SharedModule,
  ]
})
export class NotesModule { }
